import { Modal, theme, Warning } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Divider } from 'antd'
import { NAMESPACE } from 'locale'
import { carePlansConstants } from 'locale/carePlans'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface RemoveEolSectionModalProps {
  isModalVisible: boolean
  setIsModalVisible: (visible: boolean) => void
  onConfirm: () => void
  onCancel: () => void
}

const RemoveEolSectionModal: React.FC<RemoveEolSectionModalProps> = ({
  isModalVisible,
  setIsModalVisible,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation(NAMESPACE.CARE_PLANS)

  return (
    <StyledModal
      localisation={{
        title: (
          <TitleRow>
            <Warning color={theme.color.status.warning} size={24} />
            <span>
              {t(carePlansConstants.EOL_REMOVE_SECTION_CONFIRM_TITLE)}
            </span>
          </TitleRow>
        ),
        confirmText: t(carePlansConstants.EOL_REMOVE_SECTION_CONFIRM_OK),
        cancelText: t(carePlansConstants.EOL_REMOVE_SECTION_CONFIRM_CANCEL)
      }}
      onConfirm={onConfirm}
      onCancel={onCancel}
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      closeButton
      closeOnConfirm={false}
      noPadding
      confirmButtonProps={{ variant: 'danger' }}
      testId="eol-remove-section"
    >
      <Divider style={{ margin: '0' }} />
      <StyledContent>
        <Text level={1} weight="regular">
          {t(carePlansConstants.EOL_REMOVE_SECTION_CONFIRM_BODY)}
        </Text>
      </StyledContent>
    </StyledModal>
  )
}

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.neutral.color8};
`

const TitleRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`

const StyledModal = styled(Modal)`
  min-width: 600px;

  .ant-modal-content {
    padding-top: 20px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
  }

  .ant-modal-header {
    padding-bottom: 4px !important;
  }

  .ant-modal-title {
    display: flex !important;
    align-items: center;
    gap: 8px;
    font-size: 22px !important;
    font-weight: 500 !important;
    text-transform: none !important;
    color: ${({ theme }) => theme.color.neutral.color3} !important;
  }

  .ant-modal-footer {
    margin-top: 0 !important;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
`

export default RemoveEolSectionModal
